import ClickRegisterNewsletter from "../Analytics/Handlers/ClickRegisterNewsletter";
import NewsletterHandler from "../Analytics/Handlers/NewsletterHandler";
import PostViewedHandler from "../Analytics/Handlers/PostViewedHandler";
import ScrolledToBeginOfBlockHandler from "../Analytics/Handlers/ScrolledToBeginOfBlockHandler";
import ScrolledToBlockDepthHandler from "../Analytics/Handlers/ScrolledToBlockDepthHandler";
import TimeSpentHandler from "../Analytics/Handlers/TimeSpentHandler";
import TimeSpentV2Handler from "../Analytics/Handlers/TimeSpentV2Handler";
import UserDisengagedHandler from "../Analytics/Handlers/UserDisengagedHandler";

export default (window, analyticsManager) => {
    analyticsManager.addHandlers([
        new NewsletterHandler(),
        new PostViewedHandler(),
        new TimeSpentHandler(),
        new TimeSpentV2Handler(),
        new UserDisengagedHandler(),

        new ScrolledToBlockDepthHandler("body", "homePage"),
        new ClickRegisterNewsletter("input.nl_box-wrapper-form-submit"),
        new ScrolledToBeginOfBlockHandler("[data-location=footer]", "footer"),
    ]);
};
